import React from 'react';
import { GoogleLogin } from '@react-oauth/google';
import { loginWithGoogle } from '../api/auth/google';
import { getOrCreateDeviceId } from '../helpers/device';
import { useNavigate } from 'react-router-dom';

export default function Google() {
    const navigate = useNavigate();

    const handleSuccess = async (credentialResponse: any) => {
        try {
            const id_token = credentialResponse?.credential;
            if (!id_token) throw new Error('Brak id_token z Google');

            // opcjonalnie upewnij się że deviceId istnieje
            getOrCreateDeviceId();

            const data = await loginWithGoogle(id_token);

            // np. przekierowanie w zależności od roli
            if (data.user?.role === 'admin' || data.user?.role === 'worker') {
                navigate('/admin/welcome', { replace: true });
            } else {
                navigate('/admin/welcome', { replace: true });
            }

        } catch (err: any) {
            console.error('Błąd logowania Google:', err);
            alert(err?.error || err?.message || 'Błąd logowania');
        }
    };

    return <GoogleLogin onSuccess={handleSuccess} onError={() => alert('Google login failed')} />;
}
